<template>
  <div class="ecology">
    <!--  轮播 Banner -->
    <div class="banner"></div>

    <!--  表单区域 -->
    <section class="form-section">
      <div class="wrap">
        <!-- 白色表单卡片 -->
        <div class="form-card">
          <div class="form-title">申请加入</div>
          <div class="form-subtitle">填写信息，立即申请成为云创生态合作伙伴，携手共赢数智化未来！</div>

          <el-form :model="form" :rules="rules" ref="formRef" label-width="100px" class="join-form">
            <!-- 姓名 -->
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
            </el-form-item>

            <!-- 职务 -->
            <el-form-item label="职务" prop="post">
              <el-input v-model="form.post" placeholder="请输入您的职务"></el-input>
            </el-form-item>

            <!-- Email -->
            <el-form-item label="Email" prop="email">
              <el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
            </el-form-item>

            <!-- 手机号 -->
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>

            <!-- 公司名称 -->
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="form.companyName" placeholder="请输入公司名称"></el-input>
            </el-form-item>

            <!-- 公司电话 -->
            <el-form-item label="公司电话" prop="companyPhone">
              <el-input v-model="form.companyPhone" placeholder="请输入公司电话"></el-input>
            </el-form-item>

            <!-- 公司地址 -->
            <el-form-item label="公司地址" prop="companyAddress">
              <el-input v-model="form.companyAddress" placeholder="请输入公司地址"></el-input>
            </el-form-item>

            <!-- 公司网址 -->
            <el-form-item label="公司网址" prop="companyWebsite">
              <el-input v-model="form.companyWebsite" placeholder="请输入公司网址"></el-input>
            </el-form-item>

            <!-- 业务诉求 (多行文本) -->
            <el-form-item label="业务诉求" prop="businessRequirements">
              <el-input
                  type="textarea"
                  :rows="4"
                  v-model="form.businessRequirements"
                  placeholder="请描述您的业务诉求"
                  size="large">
              </el-input>
            </el-form-item>

            <!-- 了解信息 (多行文本) -->
            <el-form-item label="了解信息" prop="infoWanted">
              <el-input
                  type="textarea"
                  :rows="4"
                  v-model="form.infoWanted"
                  placeholder="请描述您希望了解的信息"
                  size="large">
              </el-input>
            </el-form-item>

            <div class="btn-wrapper">
              <el-button type="primary" class="submit-btn" @click="submitForm">
                确认提交
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ElLoading, ElMessageBox } from 'element-plus';
import newService from "@/api/newService";
export default {
  name: "ecologyIndex",
  data() {
    return {
      // 更新后的表单数据
      form: {
        name: '',
        post: '',
        email: '',
        phone: '',
        companyName: '',
        companyPhone: '',
        companyAddress: '',
        companyWebsite: '',
        businessRequirements: '',
        infoWanted: ''
      },
      // 表单验证规则 (保留了核心信息的验证，你可以根据需要增减)
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的11位手机号',
            trigger: 'blur'
          }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 提交表单
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          ElMessageBox.confirm(
              '确认提交以上信息申请加入云创生态合作伙伴吗？',
              '温馨提示',
              {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
                confirmButtonClass: 'btn-confirm-custom',
                draggable: false,
              }
          ).then(() => {
            //loading
            const loadingInstance = ElLoading.service({
              lock: true,
              text: '正在提交申请...',
              background: 'rgba(0, 0, 0, 0.7)',
            });
            //发送保存请求
            newService.saveJoinUsApply(this.form).then((res) => {
              loadingInstance.close();
              this.$message.success(res)
              this.$store.state.components='ecology'
              document.body.scrollTop=document.documentElement.scrollTop=0
            }).catch((err) => {
              loadingInstance.close();
              console.log(err)
            })
          }).catch(() => {
            this.$message.info('已取消，您可以继续修改信息');
          });
        } else {
          this.$message.error('请完善必填信息');
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
/* 原有 Banner 样式保持不变 */
.banner {
  background-image: url('../../../assets/ecology/joinUsBanner.png');
  background-size: cover;
  background-position: center;
  height: 50rem;
  position: relative;
  margin: 6.4rem auto 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}

.ecology {
  padding-top: 0rem;
  background-color: #f5f7fa; /* 整个页面最底部的背景色 */
}

.wrap {
  width: 120rem;
  padding: 10rem 0;
  margin: auto;
}

/* --- 表单区域样式 --- */
.form-section {
  width: 100%;
  background-color: #f5f7fa; /* 浅灰色背景 */
  padding-bottom: 10rem;
}

.form-card {
  background-color: #ffffff; /* 白色表单卡片 */
  border-radius: 1.2rem;
  padding: 6rem 8rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06); /* 柔和阴影 */
}

.form-title {
  font-size: 3.6rem;
  font-weight: 600;
  color: #FF0000;
  text-align: center;
  margin-bottom: 1.5rem;
}

.form-subtitle {
  font-size: 1.6rem;
  color: #353535;
  text-align: center;
  margin-bottom: 6rem;
}

.join-form {
  max-width: 90rem;
  margin: 0 auto;

  /* --- 调整 Label 样式 --- */
  :deep(.el-form-item__label) {
    font-weight: 500 !important;  /* 字体加粗 */
    color: #000000 !important;    /* 颜色加深 (深灰色) */
    padding-right: 2rem !important; /* 增加与输入框的间距 */
    font-size: 1.6rem; /* 稍微加大一点点 label 字体 */
  }

  /* 覆盖 Element Plus 默认样式，让输入框更美观 */
  :deep(.el-input__wrapper) {
    border-radius: 0.6rem;
    box-shadow: 0 0 0 1px #e4e7ed inset;
    padding: 0.5rem 1.5rem;
  }

  :deep(.el-textarea__inner) {
    border-radius: 0.6rem;
    border-color: #e4e7ed;
  }

  /* --- 放大输入框内的字体 (你输入的文字) --- */
  :deep(.el-input__inner),
  :deep(.el-textarea__inner),
  :deep(.el-input__wrapper input) {
    font-size: 1.4rem !important; /* 这里调整输入文字的大小 */
    color: #333; /* 也可以调整输入文字的颜色 */
  }

  /* 放大 placeholder 字体 */
  :deep(.el-input__inner::placeholder),
  :deep(.el-textarea__inner::placeholder),
  :deep(input::placeholder) {
    font-size: 1.6rem !important; /* 这里调整大小，根据需要改数值 */
    color: #c0c4cc; /* 也可以顺便调整 placeholder 的颜色 */
  }
}

.btn-wrapper {
  text-align: center;
}
.submit-btn {
  width: 50%;
  height: 5rem;
  font-size: 3rem;
  border-radius: 0.5rem;
  margin-top: 6rem;
  background: linear-gradient(to right, #ff0b41, #ff5252); /* 和首页按钮同款红色渐变 */
  border: none;
  box-shadow: 0 4px 15px rgba(255, 11, 65, 0.3);

  &:hover {
    background: linear-gradient(to right, #e00a3b, #e94a4a);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 11, 65, 0.4);
  }
}
</style>

<!-- 全局样式 -->
<style lang="scss">
/* 1. 弹窗整体内容区域 */
.el-message-box {
  font-size: 1.8rem !important;
}

/* 2. 弹窗标题 */
.el-message-box__title {
  font-size: 2rem !important;
  font-weight: 600;
}

/* 3. 弹窗提示内容文字 */
.el-message-box__message {
  font-size: 1.8rem !important;
  line-height: 1.6;
  padding-top: 1rem;
}

/* 4. 弹窗按钮文字 */
.el-message-box__btns .el-button {
  font-size: 1.6rem !important;
  padding: 1rem 2.5rem;
}

/* --- 5. 新增：确认按钮改成红色渐变（和提交按钮风格一致） --- */
.btn-confirm-custom {
  background: linear-gradient(to right, #ff0b41, #ff5252) !important;
  border: none !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(255, 11, 65, 0.3) !important;

  &:hover {
    background: linear-gradient(to right, #e00a3b, #e94a4a) !important;
    transform: translateY(-1px);
    box-shadow: 0 6px 15px rgba(255, 11, 65, 0.4) !important;
  }

  &:active {
    transform: translateY(0);
  }
}
</style>
